import { ArrowLeftOutlined, MenuOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Title from "antd/es/typography/Title";
import React from "react";

interface DashboardContentHeaderProps {
  onRoundsButtonClick: () => void;
  jobPostTitle: string | null;
  handleBackNavigation: () => void;
}

const DashboardContentHeader: React.FC<DashboardContentHeaderProps> = ({
  handleBackNavigation,
  jobPostTitle,
  onRoundsButtonClick,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Button
          aria-label="Back to all openings"
          onClick={handleBackNavigation}
          type="link"
          style={{ marginLeft: "-16px" }}
          className="desktop_back_button"
        >
          <ArrowLeftOutlined style={{ fontSize: "16px" }} />
        </Button>

        {jobPostTitle && (
          <Title level={4} style={{ marginTop: "8px" }}>
            {jobPostTitle}
          </Title>
        )}
      </div>
      <div className="mobile_burger_menu">
        <Button
          icon={<MenuOutlined />}
          type="primary"
          onClick={onRoundsButtonClick}
          aria-label="Click to view Rounds"
        >
          Rounds
        </Button>
      </div>
    </div>
  );
};

export default DashboardContentHeader;
